var __defProp = Object.defineProperty;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {enumerable: true, configurable: true, writable: true, value}) : obj[key] = value;
var __assign = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import Swiper from "swiper";
export default class SwiperSlider {
  constructor(defaultParams = {}) {
    this.defaultParams = defaultParams;
    this.swipers = [];
  }
  init(selector, params = {}) {
    const swipers = [];
    $(selector).each((index, item) => {
      if (!$(item).hasClass("swiper-container-initialized")) {
        let concreteSlider = new Swiper(item, this.getParams(params, item));
        swipers.push(concreteSlider);
      }
    });
    this.swipers.push(...swipers);
    return swipers;
  }
  getParams(initParams, item) {
    const htmlObjectParams = $(item).data("swiper") || {};
    htmlObjectParams.navigation = this.getNavigationParam(initParams, item);
    return __assign(__assign(__assign({}, this.defaultParams), initParams), htmlObjectParams);
  }
  getNavigationParam(initParams, item) {
    let navigation = null;
    if (!initParams || typeof initParams.navigation === "undefined") {
      navigation = {
        nextEl: $(item).parent().find(".swiper-button-next"),
        prevEl: $(item).parent().find(".swiper-button-prev")
      };
    } else {
      navigation = __assign({}, initParams.navigation);
      if (typeof initParams.navigation.nextEl === "function") {
        navigation.nextEl = initParams.navigation.nextEl(item);
      }
      if (typeof initParams.navigation.prevEl === "function") {
        navigation.prevEl = initParams.navigation.prevEl(item);
      }
    }
    return navigation;
  }
}
